import React from 'react';
import { useTranslation } from 'react-i18next';
import DwFormField from '@ui/formfield/DwFormField';
const BookAnAppointmentDateSelection = (props) => {
    const { t } = useTranslation();
    const { formdef, days, values, form } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: `${props.type == 'modal' ? 'col-8' : 'col-24'} col-lg-12` },
                React.createElement(DwFormField, { def: formdef, name: "date", type: "select", options: [{ value: '', label: t('label.select') }].concat(Object.keys(days).map((d) => {
                        let label = d;
                        let available = days[d].find((d) => d.disabled == false);
                        // console.log(days[values.date]);
                        if (window.locale === 'ja_JP') {
                            label = d.replace('.', '年').replace('.', '月').concat('日');
                        }
                        return { label: label, value: d, disabled: !available };
                    })), onChange: form.mutators.resetHours })),
            React.createElement("div", { className: `${props.type == 'modal' ? 'col-16' : 'col-24'} col-lg-12` },
                React.createElement(DwFormField, { def: formdef, name: "hour", type: "select", options: days[values.date] ? [{ value: '', label: t('label.select') }].concat(days[values.date]) : [{ value: '', label: t('label.select') }] })))));
};
export default BookAnAppointmentDateSelection;
